import React from "react";

// dependencies
import PropTypes from "prop-types";

// css
import css from "./Tabs.styl";

export const Tabs = ({ tabs, currentTab, onChange }) => (
	<div className={css.tabs}>
		{tabs.map((tab) => (
			<div
				key={tab}
				className={`${css.tab} ${currentTab === tab ? css.isActive : ""}`}
				onClick={() => onChange(tab)}
			>
				{tab}
			</div>
		))}
	</div>
);

Tabs.propTypes = {
	tabs: PropTypes.array,
	currentTab: PropTypes.string,
	onChange: PropTypes.func,
};

Tabs.defaultProps = {
	tabs: [],
	currentTab: "",
	onChange: () => {},
};
